export default "__VITE_ASSET__CSD$eQNe__"